import { EquipmentElements } from '../../equipment/models/elements/equipmentElements';
import { IPlanogram } from './planogram';
import { Element } from '../../equipment/models/elements/element';
import { Point } from '../../core/models/point';
import { PlanogramBackBehavior } from './planogramBackBehavior';
import { PlanogramFrontBehavior } from './planogramFrontBehavior';
import { PlanogramSideBehavior } from './planogramSideBehavior';
import { PlanogramTopBehavior } from './planogramTopBehavior';
import { PlanogramViewBehavior } from './planogramViewBehavior';

export class PlanogramViewBehaviorFactory {

	public static createBehavior(planogram: IPlanogram, detailedElement: Element = null, scale: number = 1, beginPoint: Point = { x: 0, y: 0 }): PlanogramViewBehavior {
		if (detailedElement) {
			switch (detailedElement.parent.type) {
				case EquipmentElements.Hook: return new PlanogramSideBehavior(planogram, detailedElement, scale, beginPoint);
				default: return new PlanogramTopBehavior(planogram, detailedElement, scale, beginPoint);
			}
		} else {
			if (planogram.flip) {
				return new PlanogramBackBehavior(planogram, detailedElement, scale, beginPoint);
			} else {
				return new PlanogramFrontBehavior(planogram, detailedElement, scale, beginPoint);
			}
		}
	}
}